import { render, staticRenderFns } from "./CustomerEditButton.vue?vue&type=template&id=62a1e31c&scoped=true"
import script from "./CustomerEditButton.vue?vue&type=script&lang=js"
export * from "./CustomerEditButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a1e31c",
  null
  
)

export default component.exports